import React, { PropTypes, Component } from 'react'
import { fromJS } from 'immutable'
import styled from 'styled-components'
import ProfileDropdownSettings from '../../components/ProfileDropdownSettings'
import Button from '../../components/Button'
import { Colors, Metrics } from '../../Themes'

const NavbarContainer = styled.div`
  width: 100%;
  height: ${Metrics.components.adminNavbar}px;
  background-color: ${Colors.white};
  border-bottom: solid 1px ${Colors.lightGrey};
  display: table;
`

const NavbarDynamicPart = styled.div`
  width: ${props =>
    props.onlySide ? '100%' : props.bothSides ? '50%' : 'auto'};
  display: table-cell;
  vertical-align: middle;

  & > * {
    margin-top: ${Metrics.margins.tiny};
    margin-bottom: ${Metrics.margins.tiny};
  }
`

const LeftSide = styled(NavbarDynamicPart)`
  padding-left: 12px;

  & > * {
    float: left;
  }
`

const RightSide = styled(NavbarDynamicPart)`
  & > * {
    float: right;
  }
`

const NavbarAction = styled(Button)`
  display: inline-block;
  white-space: nowrap;

  &.rightSideAction {
    margin-right: ${Metrics.margins.medium};
  }

  &.leftSideAction {
    margin-left: ${Metrics.margins.medium};
  }
`

const ProfileSettingsSide = styled.div`
  display: table-cell;
  vertical-align: middle;

  & > * {
    float: right;
    margin-top: ${Metrics.margins.tiny};
    margin-bottom: ${Metrics.margins.tiny};
  }
`

const ProfileSettingsContainer = styled.div`
  margin-right: 32px;
  height: ${Metrics.components.adminAvatarSize}px;
`

class AdminNavbar extends Component {
  shouldComponentUpdate (nextProps) {
    const {
      rightSideActions,
      leftSideActions,
      admin,
      dropdownLinks
    } = this.props
    if (
      !fromJS(nextProps.rightSideActions).equals(fromJS(rightSideActions)) ||
      !fromJS(nextProps.leftSideActions).equals(fromJS(leftSideActions)) ||
      !fromJS(nextProps.admin).equals(fromJS(admin)) ||
      !fromJS(nextProps.dropdownLinks).equals(fromJS(dropdownLinks))
    ) {
      return true
    }
    return false
  }

  render () {
    const {
      rightSideActions,
      leftSideActions,
      admin,
      dropdownLinks
    } = this.props

    return (
      <NavbarContainer>
        <LeftSide
          {...{
            bothSides: leftSideActions.length && rightSideActions.length,
            onlySide: leftSideActions.length && !rightSideActions.length
          }}>
          {leftSideActions &&
            leftSideActions.map((action, index) => {
              return (
                <NavbarAction
                  key={`navbar-left-action-${index}`}
                  className={'leftSideAction'}
                  {...action}
                />
              )
            })}
        </LeftSide>
        <RightSide
          {...{
            bothSides: leftSideActions.length && rightSideActions.length,
            onlySide: !leftSideActions.length && rightSideActions.length
          }}>
          {rightSideActions &&
            rightSideActions.map((action, index) => {
              return (
                <NavbarAction
                  key={`navbar-right-action-${index}`}
                  className={'rightSideAction'}
                  {...action}
                />
              )
            })}
        </RightSide>
        <ProfileSettingsSide>
          <ProfileSettingsContainer>
            <ProfileDropdownSettings
              admin={admin}
              dropdownLinks={dropdownLinks}
            />
          </ProfileSettingsContainer>
        </ProfileSettingsSide>
      </NavbarContainer>
    )
  }
}

AdminNavbar.propTypes = {
  rightSideActions: PropTypes.array,
  leftSideActions: PropTypes.array,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

AdminNavbar.defaultProps = {
  rightSideActions: [],
  leftSideActions: []
}

export default AdminNavbar



// WEBPACK FOOTER //
// ./src/components/AdminNavbar/index.js